import { render, staticRenderFns } from "./NoteClotureMail.vue?vue&type=template&id=20c695fe&scoped=true"
import script from "./NoteClotureMail.vue?vue&type=script&lang=js"
export * from "./NoteClotureMail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20c695fe",
  null
  
)

export default component.exports